import React from "react";
import styled from 'styled-components';
import Notification from "../../components/Notification";

function FilterInfoMessage({numberOfSheets, sheetIds, filters}) {
  const numberOfFilters = !filters ? 0 : filters.filters.length;
  let message = null;

  if (sheetIds[0] === 'all' && numberOfFilters === 0) {
    message = <>Showing data from the latest {numberOfSheets} sheets.</>
  }
  else if (sheetIds[0] === 'all') {
    message = <>Showing data from the latest {numberOfSheets} with {numberOfFilters} filters applied.</>
  }
  else if (numberOfFilters > 0) {
    message = <>Showing data from {numberOfSheets} sheets with {numberOfFilters} filters applied.</>
  }
  else {
    message = <>Showing data from {numberOfSheets} sheets.</>
  }

  if (message === null) {
    return null;
  }

  return (
    <Container>
      <Notification mini info>
        {message}
      </Notification>
    </Container>
  );
}

const Container = styled.div`
  padding: 0 1.875rem;
`;

export default FilterInfoMessage;